module.exports = __webpack_public_path__ + "static/media/commerce.f700191b.png";